import React, { FC, useState } from "react";
import BottomDropdown from "@/components/bottomDropdown";
import cn from "clsx";

interface SizeFormatSelectMobProps {
  options: { key: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
}

const SizeFormatSelectMob: FC<SizeFormatSelectMobProps> = ({
  options,
  value,
  onChange,
  title = "Select"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find(o => o.key === value) || options[0];

  const handleOptionClick = ({ option }: { option: any }) => {
    onChange(option.key);
  };

  return (
    <div className="size_simple_format_row">
      <div
        className="size_simple_format_select custom_select_trigger"
        onMouseDown={e => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        onClick={e => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <span>{selectedOption?.label}</span>
        <span className={cn("select_arrow_icon", { open: isOpen })} />
      </div>

      <BottomDropdown
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        selectedOption={selectedOption}
        data={options.map(o => ({ ...o, isSelected: o.key === value }))}
        onOptionClick={handleOptionClick}
        className="size_format_bottom_dropdown"
      />
    </div>
  );
};

export default SizeFormatSelectMob;
